import { Action } from '@ngrx/store';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { Place } from 'app/core/interfaces/place.interface';
import { DatesWithFlorderInfoTO } from 'app/core/store/calendar/common/calendar.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { OrderDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';

export const CALENDAR_EMPTY_DATES = 'calendar-orders:CALENDAR_EMPTY_DATES';
export const CALENDAR_ORDERS_LOAD = 'calendar-orders:CALENDAR_ORDERS_LOAD';
export const CALENDAR_ORDERS_LOAD_FAIL = 'calendar-orders:CALENDAR_ORDERS_LOAD_FAIL';
export const CALENDAR_ORDERS_LOAD_SUCCESS = 'calendar-orders:CALENDAR_ORDERS_LOAD_SUCCESS';

export const CALENDAR_ORDERS_TEMPLATE_SELECTED = 'calendar-orders:CALENDAR_ORDERS_TEMPLATE_SELECTED';

export const CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES = 'calendar-orders:CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES';
export const CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_FAIL = 'calendar-orders:CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_FAIL';
export const CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_SUCCESS = 'calendar-orders:CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_SUCCESS';
export const CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_RESET = 'calendar-orders:CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_RESET';
export const CALENDAR_ORDERS_CLEAR_STATE = 'calendar-orders:CALENDAR_ORDERS_CLEAR_STATE';

export class CalendarEmptyDatesAction implements Action {
  readonly type = CALENDAR_EMPTY_DATES;
}

export class CalendarOrdersLoadAction implements Action {
  readonly type = CALENDAR_ORDERS_LOAD;
  logPayload = ['filter'];

  ui = {
    id: CALENDAR_ORDERS_LOAD,
    busy: true,
  };

  constructor(readonly payload: { definitions: Definitions; places: { [key: string]: Place }; filter?: FlordersFilter }) {}
}

export class CalendarOrdersLoadSuccessAction implements Action {
  readonly type = CALENDAR_ORDERS_LOAD_SUCCESS;
  readonly module = 'order';

  ui = {
    id: CALENDAR_ORDERS_LOAD,
    busy: false,
  };

  constructor(readonly payload: { dates: DatesWithFlorderInfoTO; isSuperUser: boolean; selectedCustomer: Customer; customers: Customer[] }) {}
}

export class CalendarOrdersLoadFailAction implements Action {
  readonly type = CALENDAR_ORDERS_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: CALENDAR_ORDERS_LOAD,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarOrdersTemplateSelectedAction implements Action {
  readonly type = CALENDAR_ORDERS_TEMPLATE_SELECTED;

  constructor(readonly payload: OrderDetail) {}
}

export class CalendarOrdersRequestOrderDeliveryDatesAction implements Action {
  readonly type = CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES;

  ui = {
    id: CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES,
    busy: true,
  };
}

export class CalendarOrdersDeliveryDatesReset implements Action {
  readonly type = CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_RESET;
}

export class CalendarOrdersRequestOrderDeliveryDatesSuccessAction implements Action {
  readonly type = CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_SUCCESS;

  ui = {
    id: CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarOrdersRequestOrderDeliveryDatesFailAction implements Action {
  readonly type = CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_FAIL;
  logPayload = true;

  ui = {
    id: CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarOrdersClearStateAction implements Action {
  readonly type = CALENDAR_ORDERS_CLEAR_STATE;
}

export type Actions =
  | CalendarEmptyDatesAction
  | CalendarOrdersLoadAction
  | CalendarOrdersLoadSuccessAction
  | CalendarOrdersLoadFailAction
  | CalendarOrdersTemplateSelectedAction
  | CalendarOrdersRequestOrderDeliveryDatesAction
  | CalendarOrdersRequestOrderDeliveryDatesSuccessAction
  | CalendarOrdersRequestOrderDeliveryDatesFailAction
  | CalendarOrdersClearStateAction
  | CalendarOrdersDeliveryDatesReset;
